package com.example.readingnotes.domain.model

import kotlinx.datetime.Instant

data class Comment(
    val id: String, // UUID
    val postId: String, // UUID
    val tenantId: String? = null, // UUID
    val authorName: String,
    val content: String,
    val createdAt: Instant,
)
